import { Routes, Route, Navigate } from "react-router-dom";
import { SingleCard } from "./layouts";
import {
  LoginForm,
  ResetPasswordForm,
  ChangePasswordForm,
  CreateAccountForm,
} from "./components";
import OTP from "@components/otp/otp";

export default function UnauthenticatedContent() {
  return (
    <div
      className="w-full flex justify-center lg:justify-end bg-none md:bg-cover md:bg-center md:bg-no-repeat"
      style={{
        backgroundImage:
          window.innerWidth >= 768
            ? `url(${process.env.REACT_APP_PUBLIC_URL}/login-bg-image.jpg)`
            : "none",
      }}
    >
      <Routes>
        <Route
          path="/login"
          element={
            <SingleCard title="Sign in" className="lg:pb-3 lg:me-[150px]">
              <LoginForm />
            </SingleCard>
          }
        />
        <Route
          path="/create-account"
          element={
            <SingleCard title="Sign up" className="lg:pb-3 lg:me-[150px]">
              <CreateAccountForm />
            </SingleCard>
          }
        />
        <Route
          path="/reset-password"
          element={
            <SingleCard
              title="Forgot Password"
              className="lg:pb-3 lg:me-[150px]"
            >
              <ResetPasswordForm />
            </SingleCard>
          }
        />
        <Route
          path="/change-password/:recoveryCode"
          element={
            <SingleCard
              title="Change Password"
              className="lg:pb-3 lg:me-[150px]"
            >
              <ChangePasswordForm />
            </SingleCard>
          }
        />
        <Route
          path="/otp"
          element={
            <SingleCard title="Verify OTP" className="lg:pb-3 lg:me-[150px]">
              <OTP />
            </SingleCard>
          }
        />
        <Route path="*" element={<Navigate to={"/login"} />}></Route>
      </Routes>
    </div>
  );
}
